export default {
	state: {
		firstName: null,
		lastName: null,
		jmbg: null,
		triggerType: '',
		cashoutMessage: '',
	},
	getters: {
		firstName: (state) => state.firstName,
		lastName: (state) => state.lastName,
		jmbg: (state) => state.jmbg,
		userInfo: ({ firstName, lastName, jmbg }) => (jmbg ? { firstName, lastName, jmbg } : null),
		cashoutMessage: (state) => state.cashoutMessage,
		triggerType: (state) => state.triggerType,
	},
	mutations: {
		setUserInfo(state, userInfo) {
			if (userInfo) {
				state.firstName = userInfo.firstName;
				state.lastName = userInfo.lastName;
				state.jmbg = userInfo.jmbg;
			} else {
				state.firstName = null;
				state.lastName = null;
				state.jmbg = null;
			}
		},
		deleteUserInfo(state) {
			state.firstName = null;
			state.lastName = null;
			state.jmbg = null;
		},
		setTriggerType(state, triggerType) {
			state.triggerType = triggerType;
		},
		setCashoutMessage(state, cashoutMessage) {
			state.cashoutMessage = cashoutMessage;
		},
		resetTriggerState(state) {
			state.firstName = null;
			state.lastName = null;
			state.jmbg = null;
			state.cashoutMessage = '';
			state.triggerType = '';
		},
	},
	actions: {
		setUserInfoAction({ commit }, { userInfo }) {
			commit('setUserInfo', userInfo);
		},
		deleteUserInfoAction({ commit }) {
			commit('deleteUserInfo');
		},
		setTriggerTypeAction({ commit }, triggerType) {
			commit('setTriggerType', triggerType);
		},
		setCashoutMessageAction({ commit }, cashoutMessage) {
			commit('setCashoutMessage', cashoutMessage);
		},
		resetTriggerStateAction({ commit }) {
			commit('resetTriggerState');
		},
	},
};
